<template>
<div>edit</div>
</template>

<script>
export default {
  name: 'EditAdminReservation',
}
</script>

<style scoped>

</style>
